var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-subheader',{staticClass:"font-weight-regular"},[(_vm.hasErrors)?_c('span',{staticClass:"error--text"},[_vm._v("\n    Please checkout errors to resubmit.\n  ")]):_c('span',{staticClass:"info--text"},[_vm._v("\n    You may resubmit your data.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }